import { render, staticRenderFns } from "./InvoiceBookTemplate.vue?vue&type=template&id=83f4cf88&"
import script from "./InvoiceBookTemplate.vue?vue&type=script&lang=js&"
export * from "./InvoiceBookTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports